module.exports = __webpack_public_path__ + "img/close_white_border.8a5c566a.png";